import { useState } from "react";

export const useSelectionRequired = (value) => {
    const [submitted, setSubmitted] = useState(false);
    return { hasError: !value && submitted, setSubmitted };
};